<esn-icon name="check-circle" [size]="30" />
